import { Chip, IconClose, IconedButton, Text } from '@bbl-digital/snorre-v2'
import { useFileuploadPickerContext } from '../context/useFileuploadPickerContext'
import { FileWrapper } from '../types/types'
import { cn } from 'shared/utils/cn'
import FileIcon from './FileIcon'

type ModalFileItemProps = {
  file: FileWrapper
}

const SelectedFileItem = ({ file }: ModalFileItemProps) => {
  const { removeFile } = useFileuploadPickerContext()

  const validation = file.validation

  return (
    <div>
      <div
        className={cn(
          'flex justify-between items-center border rounded-md border-border-subtle mb-1 p-1 gap-2',
          file?.validation ? 'border-ui-errorLight' : ''
        )}
      >
        <div className="flex gap-1 items-center min-w-0 w-full">
          <FileIcon type={file.mimeType} className="ml-0 shrink-0" />

          <Text className="truncate w-full" title={file.name}>
            {file.name}
          </Text>
        </div>

        <div className="flex items-center gap-1 shrink-0">
          <Chip label={file.isArchive ? 'Arkiv' : 'Lokal'}></Chip>
          <IconedButton
            label="Fjern fil"
            variant="ghost"
            small
            icon={<IconClose />}
            onClick={() => removeFile(file)}
          />
        </div>
      </div>
      {validation && (
        <Text className="text-ui-errorDark mb-2">{validation.message}</Text>
      )}
    </div>
  )
}

export default SelectedFileItem
